import { IndustryInterface } from '../interfaces/industry.interface';

export const INDUSTRIES: IndustryInterface[] = [
  { value: 'retail', label: 'Retail & Shopping', icon: 'shopping_basket' },
  { value: 'supermarket', label: 'Supermarkets', icon: 'store' },
  { value: 'pharmacy', label: 'Pharmacies', icon: 'local_pharmacy' },
  { value: 'restaurant', label: 'Restaurants & Cafes', icon: 'restaurant' },
  { value: 'fashion', label: 'Fashion & Apparel', icon: 'checkroom' },
  { value: 'electronics', label: 'Electronics & Technology', icon: 'devices' },
  { value: 'furniture', label: 'Furniture & Home Goods', icon: 'chair' },
  { value: 'jewelry', label: 'Jewelry & Accessories', icon: 'diamond' },
  { value: 'automotive', label: 'Automotive & Parts', icon: 'directions_car' },
  { value: 'healthcare', label: 'Healthcare & Medical', icon: 'medical_services' },
  { value: 'education', label: 'Education & Training', icon: 'school' },
  { value: 'manufacturing', label: 'Manufacturing', icon: 'precision_manufacturing' },
  { value: 'construction', label: 'Construction & Materials', icon: 'construction' },
  { value: 'logistics', label: 'Logistics & Transportation', icon: 'local_shipping' },
  { value: 'agriculture', label: 'Agriculture & Farming', icon: 'agriculture' },
  { value: 'hospitality', label: 'Hospitality & Tourism', icon: 'hotel' },
  { value: 'sports', label: 'Sports & Recreation', icon: 'sports_soccer' },
  { value: 'beauty', label: 'Beauty & Cosmetics', icon: 'spa' },
  { value: 'books', label: 'Books & Stationery', icon: 'menu_book' },
  { value: 'pets', label: 'Pets & Supplies', icon: 'pets' },
  { value: 'art', label: 'Art & Crafts', icon: 'palette' },
  { value: 'toys', label: 'Toys & Games', icon: 'toys' },
  { value: 'food', label: 'Food & Beverages', icon: 'restaurant_menu' },
  { value: 'other', label: 'Other', icon: 'more_horiz' }
];